export class SaleType {
	ID:number = 0;
	DisplayedName:string = "";

	public constructor(data:any){
		this.ID = data.ID;
		this.DisplayedName = data.DisplayedName;
	}

}